import { ApiAvailables, ApiScoreCard, ApiScoreCardv2, ISimulation } from '@/types';
import { mapSimulationWithHistory } from '@/utils';

/**
 * Maps API simulations to frontend ISimulation format.
 *
 * @param apiAvailables - Array of ApiAvailables from the API
 * @param apiScorecards - Array of ApiScoreCard or ApiScoreCardv2 from the API
 *
 * @returns Array of ISimulation formatted for the frontend
 */
export function mapApiSimulationsToFrontend({
  apiAvailables,
  apiScorecards,
}: {
  apiAvailables: ApiAvailables[];
  apiScorecards: (ApiScoreCard | ApiScoreCardv2)[];
}): ISimulation[] {
  const mapHistory = (simulation: ISimulation) => {
    return mapSimulationWithHistory({ simulation, scorecards: apiScorecards });
  };

  return apiAvailables.flatMap((available) => {
    const availableSimulations: ISimulation[] = [
      available.certificationPractice,
      available.certificationSimulation,
      ...(available.simulations ?? []),
    ].filter((s) => s !== null && s !== undefined);

    return availableSimulations.map(mapHistory) || [];
  });
}
